<template>
    <div class="recharge-now">
        <div class="recharge-logo" @click="rechargeNow"></div>
        <div class="account-info">
            <div class="account-title">
                <span></span>
                <div>当前账户剩余时间</div>
                <span></span>
                <div @click="signOut" class="exit-login"><span class="exit"></span><div>退出</div></div>
            </div>
            <div class="account-box">
                <div class="account-box-main">
                    <div>{{  secondsToTime(limitTime, 'day')[0] }}</div>
                    <span class="unit">天</span>
                    <i>:</i>
                    <div>{{ secondsToTime(limitTime, 'day')[1] }}</div>
                    <span class="unit">时</span>
                    <i>:</i>
                    <div>{{ secondsToTime(limitTime, 'day')[2] }}</div>
                    <span class="unit">分</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'
import { secondsToTime } from '@/utils/util'

export default {
    computed: {
        ...mapGetters(['panelStatus'])
    },
    props: {
        limitTime: {
            type: Number,
            default: 0
        },
    },
    components: {
    },
    data () {
        return {
            secondsToTime,
        }
    },

    mounted () {
    },
    methods: {
        ...mapMutations(['setPanelStatus', 'setShowLogin']),
        rechargeNow () {
            this.$emit('buyTime')
        },
        signOut () {
            this.$emit('signOut')
        }
    }
}
</script>
<style scoped lang="less">
    .recharge-now {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        z-index: 5;
        .recharge-logo {
            width: 433px;
            height: 116px;
            //background-image: url('@/assets/images/recharge/recharge-now.png');
            background-image: url("@/assets/images/gameInfo/get-more-time.png");
            background-size: 100% 100%;
            background-repeat: no-repeat;
            cursor: pointer;
        }
        .account-info {
            width: 708px;
            height: 220px;
            background-image: url('@/assets/images/recharge/recharge-bg.png');
            background-size: 100% 100%;
            background-repeat: no-repeat;
            display: flex;
            padding: 10px;
            flex-direction: column;
        }
        .account-title {
            width: 100%;
            height: 60px;
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #B0CAEB;
            font-size: 28px;
            font-family: Source Han Sans CN;
            font-weight: bold;
            >div {
                margin: 0 43px;
            }
            span {
                display: block;
                width: 14px;
                height: 14px;
                background-image: url('@/assets/images/recharge/tip.png');
                background-size: 100% 100%;
                background-repeat: no-repeat;
            }
        }
        .account-box {
            display: flex;
            align-items: center;
            padding: 0 10px 0 10px;
            box-sizing: border-box;
            justify-content: center;
            height: 140px;
            color: #FFD293;
            font-size: 90px;
            font-weight: bold;
            &-main {
                display: flex;
                height: 90px;
                align-items: center;
            }
            i {
                font-style: normal;
                margin: 20px;
                //font-size: 12px;
            }
            span {
                font-size: 12px;
                display: flex;
                height: 80%;
                align-items: flex-end;
            }
        }
        .exit-login {
            position: absolute;
            //width: 100px;
            display: flex;
            align-items: center;
            right: 10px;
            top: 50%;
            transform: translateY(-50%);
            font-size: 14px;
            //background: #000000;
            color: #ffffff;
            padding: 10px;
            cursor: pointer;
            margin: 0 !important;
            .exit {
                width: 15px;
                height: 13px;
                display: block;
                background-image: url("../assets/images/home/exit.png");
                background-repeat: no-repeat;
                background-size: 100% 100%;
            }
        }
    }
</style>
